<template>
  <div>
    <div class="accordion" v-if="!loading">
      <div class="label" v-if="cloudProviderHasAic">*Also ICMP and ESC</div>
      <div v-for="technology in technologies" :key="technology.name">
        <div class="accordion__item" :class="{ open: isOpen.includes(technology.name) }">
          <div class="accordion__item--title" @click="toggle(technology.name)">
            <h4 v-if="technology.name">{{ technology.name }}</h4>
          </div>
          <div class="accordion__item--content">
            <div v-for="imageLevel in technology.imageLevels" :key="imageLevel.name" class="level">
              <h3 v-if="imageLevel.name">{{ imageLevel.name }}</h3>
              <div v-for="image in imageLevel.images" :key="image.id">
                <a
                  class="image external-link"
                  :href="image.locationUrl"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {{ image.name.trim() }}<span v-if="image.hasAic">*</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <p>Loading...</p>
    </div>
  </div>
</template>

<script>
import { HardenedImageQuery } from './CIS-Hardened-Images-Cloud-Provider-List.graphql';
import { useQuery } from '@vue/apollo-composable';

export default {
  name: 'CIS-Hardened-Images-Cloud-Provider-List',
  props: {
    fields: {
      type: Object,
      default: () => ({})
    }
  },
  data: function () {
    return {
      isOpen: []
    };
  },
  setup(props) {
    const { result, loading, error } = useQuery(HardenedImageQuery);

    return {
      result,
      loading,
      error
    };
  },
  computed: {
    cloudProvider() {
      return this.fields?.cloudProvider?.fields?.name?.value;
    },
    cloudProviderHasAic() {
      return this.fields?.cloudProvider?.fields?.hasAic?.value;
    },
    technologies() {
      if (this.loading) return [];

      const cloudImages = this.result?.items?.children.filter(
        (c) => c.cloudProvider?.value === this.cloudProvider
      );
      const aic = 'AWS Intelligence Community';
      const aicImages = this.cloudProviderHasAic
        ? this.result?.items?.children.filter((c) => c.cloudProvider?.value === aic)
        : [];

      if (!cloudImages || !aicImages) return [];

      const hasAic = (image) => {
        return (
          aicImages.filter(
            (i) =>
              i.imageName?.value?.toUpperCase().trim() ===
                image.imageName.value?.toUpperCase().trim() &&
              i.imageLevel?.value?.toUpperCase().trim() ===
                image.imageLevel?.value?.toUpperCase().trim()
          ).length > 0
        );
      };

      const technologies = [
        ...new Map(
          cloudImages.map((t) => [
            t.technologyName.value,
            {
              name: t.technologyName.value,
              imageLevels: [
                ...new Map(
                  cloudImages
                    .filter((c) => c.technologyName.value === t.technologyName.value)
                    .map((l) => [
                      l.imageLevel.value,
                      {
                        name: l.imageLevel.value,
                        images: cloudImages
                          .filter(
                            (c) =>
                              c.technologyName.value === t.technologyName.value &&
                              c.imageLevel.value === l.imageLevel.value
                          )
                          .map((i) => ({
                            id: i.id,
                            name: i.imageName.value,
                            locationUrl: i.locationUrl.value,
                            hasAic: hasAic(i)
                          }))
                          .reverse()
                      }
                    ])
                  //todo; sort this by imageLevel name (Level 1, Level 2, STIG)
                ).values()
              ]
            }
          ])
        ).values()
      ].sort((a, b) => {
        return a.name.localeCompare(b.name);
      });

      return technologies;
    }
  },
  methods: {
    toggle(index) {
      if (this.isOpen.includes(index)) {
        this.isOpen = this.isOpen.filter((i) => i !== index);
        return;
      }

      this.isOpen.push(index);
    }
  }
};
</script>
<style lang="scss" scoped>
.label {
  font-size: 1.4rem;
  font-weight: 400;
  color: $gray;
  padding: 0;
  text-align: left;
}

.accordion__item {
  &.open {
    background: transparent;
  }

  &--title {
    &:hover {
      background: transparent;
    }
  }

  &--content {
    .level {
      margin-bottom: 4rem;
    }

    .level:last-child {
      margin-bottom: 0;
    }

    .image {
      display: inline-block;
      margin-bottom: 1.5rem;
    }
  }

  .external-link {
    &:after {
      margin-left: 1rem;
    }
  }
}
</style>
